import script from "./ElementAnimationPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementAnimationPanel.vue?vue&type=script&lang=ts&setup=true"

import "./ElementAnimationPanel.vue?vue&type=style&index=0&id=270c5d30&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-270c5d30"]])

export default __exports__